import { useStore } from "vuex";
import { TYPES } from "@/types";

export const getCompanyLogoUrl = (
  positionId: number | string | string[] | undefined
) => {
  const store = useStore();
  let id;
  if (positionId) {
    id = positionId;
  } else {
    id = store?.getters?.publicContainer?.id;
  }

  if (!id) return null;

  return TYPES.BaseURL + "/api/public/open/" + id + "/logo";
};

export const getImageUrl = (containerId: number, key: string) => {
  return `${TYPES.BaseURL}/api/public/open/containers/${containerId}/assets?id=assets/${key}`;
};

interface BannerImageOptions {
  minWidth?: number;
  minHeight?: number;
  maxWidth?: number;
  maxHeight?: number;
  maxSize?: number;
}

export const handleImageUpload = (
  event: any,
  options?: BannerImageOptions,
  callback?: (image: string) => void
) => {
  const minWidth = options.minWidth;
  const minHeight = options.minHeight;
  const maxWidth = options.maxWidth;
  const maxHeight = options.maxHeight;
  const file = event.target.files[0];
  if (file) {
    if (file.size > options.maxSize) {
      alert("Filen är för stor. Max 5MB");
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      const image = new Image();
      image.src = e.target.result as string;
      image.onload = () => {
        if (image.width < minWidth || image.height < minHeight) {
          alert(
            `Bilden är för liten. Minsta storlek är ${minWidth}x${minHeight}`
          );
          return;
        } else if (image.width > maxWidth || image.height > maxHeight) {
          alert(`Bilden är för stor. Max storlek är ${maxWidth}x${maxHeight}`);
          return;
        }
        callback(e.target.result as string);
      };
    };
  }
};

function readFile(blob: any, callback: (image: string) => void) {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  reader.onload = (e) => {
    callback(e.target.result as string);
  };
}
export function fetchImage(url: string, callback: (image: string) => void) {
  fetch(url)
    .then((response) => response.blob())
    .then((blob) => readFile(blob, callback))
    .catch((error) => console.error(error));
}

export function imageDoesExist(image: string): Promise<boolean> {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = image;
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
  });
}
